module.exports = "/virtual-football/img/video/result-score.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/result-score.png
// module id = 309
// module chunks = 6